import {
  isEmptySale,
  hasLineItems,
  isMarkedAsUnfulfilled,
  isReturn,
  isBlindReturn,
  isLegacyServiceSale,
} from '../../../functions/sale'
import { hasServiceOrder } from '../../../functions/service'
import { useAppSelector } from '../../../state/hooks'
import { selectCurrentSale } from '../../../state/slices/currentSale/currentSaleSlice'
import { getFeatureFromCache } from '../../../util/feature-cache'

/**
 * hook to determine display and enable/ disable state of more action menu items
 */
export const useMoreActionsPopover = (shouldDisableActions: boolean) => {
  const sale = useAppSelector(selectCurrentSale)

  const saleState = {
    isEmptySale: isEmptySale(sale),
    hasLineItems: hasLineItems(sale),
    isMarkedAsUnfulfilled: isMarkedAsUnfulfilled(sale.status),
    isReturn: isReturn(sale) || isBlindReturn(sale),
    hasServiceOrder:
      hasServiceOrder(sale.serviceFields, sale.customFields) ||
      isLegacyServiceSale(sale.status),
  }
  const shouldDisableQuote =
    shouldDisableActions ||
    !saleState.hasLineItems ||
    saleState.isMarkedAsUnfulfilled ||
    saleState.isReturn ||
    saleState.hasServiceOrder

  const shouldDisableService =
    shouldDisableActions ||
    saleState.isReturn ||
    saleState.hasServiceOrder ||
    !saleState.hasLineItems

  const shouldDisableDiscardSale = shouldDisableActions

  const isServiceOrderEnabled = getFeatureFromCache('enable_service_orders')
  const isFulfilmentLifB3Enabled = getFeatureFromCache('fulfillment_lif_b3')

  const shouldDisableMarkAsUnfulfilled =
    shouldDisableActions ||
    saleState.isReturn ||
    (!isFulfilmentLifB3Enabled &&
      (saleState.isMarkedAsUnfulfilled || saleState.isEmptySale)) ||
    (isFulfilmentLifB3Enabled && !saleState.hasLineItems)

  return {
    shouldDisableQuote,
    shouldDisableService,
    shouldDisableMarkAsUnfulfilled,
    shouldDisableDiscardSale,
    isServiceOrderEnabled,
    isFulfilmentLifB3Enabled,
  }
}
